import type { Dispatch, SetStateAction } from "react";
import "../../../../styles/common/button.scss";

export interface OptionType {
  name: string;
  id: number;
}

interface SwitchButtonProps {
  options: OptionType[];
  active: number;
  setActive: Dispatch<SetStateAction<number>>;
}

const GxMultiSwitchButton = ({
  options,
  active,
  setActive,
}: SwitchButtonProps) => {
  return (
    <div className="gx-multi-switch-button">
      {options.map((option: OptionType) => (
        <button
          key={option.id}
          className={`gx-multi-switch-button-normal gx-font-medium ${
            active === option.id
              ? "gx-multi-switch-button-active"
              : ""
          }`}
          onClick={() => setActive(option.id)}
          type="button"
        >
          {option.name}
        </button>
      ))}
    </div>
  );
};

export default GxMultiSwitchButton;
